import { BaseService } from './base.service';
import { User } from '../models/user.models';

export default class GroupsService extends BaseService {
  public async getGroups(teamId: string | number) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.get(`${this.backendUrl}/team/${teamId}/groups`, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async addGroup(teamId: string | number, name: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.post(
      `${this.backendUrl}/team/${teamId}/groups`,
      { name },
      {
        headers: {
          'x-access-token': user.token,
        },
      }
    );
  }

  public async deleteGroup(teamId: string | number, groupId: string | number) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.delete(`${this.backendUrl}/team/${teamId}/group/${groupId}`, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async editGroup(teamId: string | number, groupId: string | number, name: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.put(
      `${this.backendUrl}/team/${teamId}/group/${groupId}`,
      { name },
      {
        headers: {
          'x-access-token': user.token,
        },
      }
    );
  }

  public async addMembersToGroup(teamId: string | number, groupId: string | number, members: any[]) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.post(
      `${this.backendUrl}/team/${teamId}/group/${groupId}/members`,
      { members },
      {
        headers: {
          'x-access-token': user.token,
        },
      }
    );
  }

  public async removeMembersFromGroup(teamId: string | number, groupId: string | number, members: any[]) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.put(
      `${this.backendUrl}/team/${teamId}/group/${groupId}/members`,
      { members },
      {
        headers: {
          'x-access-token': user.token,
        },
      }
    );
  }
}
